/* eslint-disable max-len */
import { createSvgIcon } from "../utils";

// SVG - 32 width, 32 height

const CloseHeavy = createSvgIcon(
    <path d="M8.469 8.469a1.6 1.6 0 012.262 0L16 13.737l5.269-5.268a1.6 1.6 0 012.262 2.262L18.263 16l5.268 5.269a1.6 1.6 0 01-2.262 2.262L16 18.263l-5.269 5.268A1.6 1.6 0 018.47 21.27L13.737 16 8.47 10.731a1.6 1.6 0 010-2.262z" />,
    "CloseHeavy",
);

export default CloseHeavy;
